import React from 'react';
import PropTypes from 'prop-types';
import asSelectListOption from './asSelectListOption';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

const TestableDiv = testable(QA_MALT, 'div');

const SelectListOption = props => <TestableDiv {...props} />;

SelectListOption.displayName = 'SelectListOption';
SelectListOption.propTypes = {
  /**
   * The value of the dropdown. Must be unique within a `<Dropdown />`,
   * defaults to `children`
   */
  value: PropTypes.any,
  /** Add a custom className to the option */
  className: PropTypes.string,
  /** The content of the option. Also serves as value if `value` prop is not set */
  children: PropTypes.node.isRequired,
  /** define a testid for the option */
  testId: PropTypes.string,
  /** set disabled state */
  disabled: PropTypes.bool,
};

const DecoratedSelectListOption = asSelectListOption(SelectListOption);
DecoratedSelectListOption.displayName = SelectListOption.displayName;

export default DecoratedSelectListOption;
